/*
* Usage:
*
* <button data-email data-action-value="mailto:admin@thisiscold.com">admin@thisiscold.com</button>
*
* <button data-phone data-action-value="tel:+44723843278">+44 (0) 2387 237 232</button>
*/

import {findMany} from '../helpers';
import PhonePopUp from './phone';
import EmailPopUp from './email';
import CopyPopUp from './link';

findMany('[data-phone]').forEach(el => new PhonePopUp(el));
findMany('[data-email]').forEach(el => new EmailPopUp(el));
findMany('[data-copy]').forEach(el => new CopyPopUp(el));

